import digitalWalletStore from "@/stores/digital.wallet.store";
import { FormControl, FormControlLabel, Grid, Radio, RadioGroup } from "@mui/material";
import { FC, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { ReactComponent as AttentionIcon } from "../../assets/icons/attention-icon.svg";
import { formatAmount } from "@/util";

interface IBulkWalletsUpdateStepThree { }

const BulkWalletsUpdateStepThree: FC<IBulkWalletsUpdateStepThree> = () => {
    const { t } = useTranslation();
    const request = digitalWalletStore.bulkUpdateDigitalWalletsRequest;
    const [isReset, setIsReset] = useState<boolean>(false);
    const [isDisabledReset, setIsDisabledReset] = useState<boolean>(false);
    useEffect(() => {
        setIsReset(request.isReset);
        if (request.amount && request.amount < 0) {
            setIsReset(false);
            digitalWalletStore.setBulkUpdateDigitalWalletsRequest({
                ...request,
                isReset: false,
            });
            setIsDisabledReset(true);
        }
    }, []);
    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        let val = (event.target as HTMLInputElement).value;
        setIsReset(val === "true");
        digitalWalletStore.setBulkUpdateDigitalWalletsRequest({
            ...request,
            isReset: val === "true",
        });
    };

    return (
        <Grid className="bulk-update-steps-content" sx={{ maxWidth: "330px" }}>
            <Grid
                sx={{
                    display: "grid",
                    gridTemplateColumns: "0.1fr 1fr",
                    gap: "10px",
                    marginBottom: "25px",
                }}
            >
                <AttentionIcon />
                <Grid className="bulk-update-steps-title">
                    {t("digitalWallet.DoYouWantToResetTheBalanceInAllSelectedWallets?")}
                </Grid>
            </Grid>
            <Grid className="bulk-update-step-three-content">
                <Grid
                    sx={{
                        marginBottom: "10px",
                    }}
                >
                    <span
                        style={{
                            fontWeight: "600",
                            fontSize: "14px",
                            lineHeight: "16px",
                            color: "#586A84",
                        }}
                    >
                        {t("digitalWallet.IfYouReset")}
                    </span>{" "}
                    -{" "}
                    <span
                        style={{
                            fontWeight: "400",
                            fontSize: "14px",
                            lineHeight: "16px",
                            color: "#586A84",
                        }}
                    >
                        {t("digitalWallet.AllBalancesInTheWalletsWillBeResetAndReloadedInTheAmountOfNIS")}{" "}
                        {request.amount && formatAmount(request.amount, 1)}{" "}
                    </span>
                </Grid>
                <Grid
                    sx={{
                        marginBottom: "17px",
                    }}
                >
                    <span
                        style={{
                            fontWeight: "600",
                            fontSize: "14px",
                            lineHeight: "16px",
                            color: "#586A84",
                        }}
                    >
                        {t("digitalWallet.IfYouDontReset")}
                    </span>{" "}
                    -{" "}
                    <span
                        style={{
                            fontWeight: "400",
                            fontSize: "14px",
                            lineHeight: "16px",
                            color: "#586A84",
                        }}
                    >
                        <span>{t("digitalWallet.TheAmountOfNIS")}</span>{" "}
                        {request.amount && formatAmount(request.amount, 1)}{" "}
                        <span>{t("digitalWallet.WillBeAddedToTheBalancesInTheWallets")}</span>
                    </span>
                </Grid>
                <Grid className="radio-group">
                    <FormControl>
                        <RadioGroup
                            aria-labelledby="demo-controlled-radio-buttons-group"
                            name="controlled-radio-buttons-group"
                            value={request.isReset.toString()}
                            onChange={handleChange}
                        >
                            <FormControlLabel disabled={isDisabledReset} value="true" control={<Radio />} label={t("digitalWallet.Reset")} />
                            <FormControlLabel disabled={isDisabledReset} value="false" control={<Radio />} label={t("digitalWallet.NoReset")} />
                        </RadioGroup>
                    </FormControl>
                </Grid>
            </Grid>
        </Grid>
    );
};

export default BulkWalletsUpdateStepThree;
